import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatEur } from "@/lib/api";
import { CheckCircle2, Loader2, Home } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function PaymentSuccess() {
  const { branding } = useApp();
  const [status, setStatus] = useState("checking");
  const [reg, setReg] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); setReg(data.registration); return; }
        if (data.payment_status === "processing" || data.status === "processing") { setStatus("processing"); setReg(data.registration); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch (e) { /* retry */ }
      if (tries < 12) setTimeout(poll, 2000); else setStatus("error");
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-xl p-8 sm:p-10 max-w-lg w-full text-center">
        {branding?.logo_url && <img src={branding.logo_url} alt="Repsol" className="h-10 mx-auto mb-6" />}
        {status === "checking" && (<><Loader2 className="animate-spin mx-auto brand-navy" size={48} /><h1 className="text-2xl font-black brand-navy mt-4">Confirmando tu pago…</h1><p className="text-slate-500 mt-2">Un momento, por favor.</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 className="mx-auto text-emerald-500" size={64} />
          <h1 className="text-2xl sm:text-3xl font-black brand-navy mt-4">¡Inscripción confirmada!</h1>
          <p className="text-slate-500 mt-2">Hemos enviado un email de confirmación a tu correo.</p>
          {reg && (
            <div className="bg-slate-50 rounded-2xl p-5 mt-6 text-left">
              <p className="text-sm text-slate-400">Referencia</p>
              <p className="font-black brand-navy text-lg" data-testid="success-reference">{reg.reference}</p>
              <p className="mt-3 font-bold text-slate-700">{reg.activity_title}</p>
              <p className="text-sm text-slate-500 mt-1">Total pagado: <span className="font-bold brand-navy">{formatEur(reg.total)}</span></p>
            </div>
          )}
        </>)}
        {status === "processing" && (<>
          <Loader2 className="mx-auto text-[#003284]" size={56} />
          <h1 className="text-2xl sm:text-3xl font-black brand-navy mt-4">Pago en proceso</h1>
          <p className="text-slate-500 mt-2">Tu pago por domiciliación / transferencia SEPA se está tramitando. Tu plaza queda reservada un máximo de 48 h hasta la confirmación bancaria; te enviaremos un email cuando se complete (o si no llega a confirmarse).</p>
          {reg && (
            <div className="bg-slate-50 rounded-2xl p-5 mt-6 text-left">
              <p className="text-sm text-slate-400">Referencia</p>
              <p className="font-black brand-navy text-lg" data-testid="processing-reference">{reg.reference}</p>
              <p className="mt-3 font-bold text-slate-700">{reg.activity_title}</p>
              <p className="text-sm text-slate-500 mt-1">Importe: <span className="font-bold brand-navy">{formatEur(reg.total)}</span></p>
            </div>
          )}
        </>)}
        {status === "error" && (<><h1 className="text-2xl font-black text-[#E31837] mt-4">No pudimos confirmar el pago</h1><p className="text-slate-500 mt-2">Si crees que es un error, contacta con nosotros.</p></>)}
        <button data-testid="success-home-btn" onClick={() => navigate("/calendario")} className="mt-8 inline-flex items-center gap-2 bg-brand-navy text-white font-bold rounded-full px-8 py-3 hover:bg-[#FF7F27] transition-colors"><Home size={18} /> Volver al calendario</button>
      </div>
    </div>
  );
}
